import crud from '@/crud/form/form'
import resources from '../../resources'

export default {
  resourcePath: '/v1/patient/settings/dependents',
  mixins: [crud, resources]
}



// WEBPACK FOOTER //
// ./src/app/settings/dependents/form/resources/index.js